// format phone number
export function formatPhone(phone) {
  if (!phone) throw new Error("Phone number not provided!");
  if (phone.length !== 10) throw new Error("Phone number must be 10 digits!");
  if (phone.match(/[a-z]/i)) throw new Error("Phone number must be digits only!");
  return "+1" + phone;
}
